import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

export default () => (
	<Switch>
		<Route path="/admin/divisiongroups" exact component={List} />
		<Route path="/admin/divisiongroups/create" component={Edit} />
		<Route path="/admin/divisiongroups/:id" component={Edit} />
	</Switch>
);
